// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ThemeManager } from "../../../Controls/misc/ThemeManager.js";
import { SolidBrush } from "../../../Commons/Graphics.js";
import { DataCacheToolToolType } from "../DataCacheToolEnums.js";
import { DataCacheTool } from "../DataCacheTool.js";
import { DynProperty } from "../../DynProperty.js";

export let InfoLineDataCacheTool = function ()
{
    this.backgroundColor = null;
    this.backgroundBrush = null;

    DataCacheTool.apply(this);

    this.ToolType = DataCacheToolToolType.InfoLine;
    this.InitPoints(2);
};

InfoLineDataCacheTool.prototype = Object.create(DataCacheTool.prototype);

Object.defineProperty(InfoLineDataCacheTool.prototype, 'BackgroundColor', {
    get: function () { return this.backgroundColor; },
    set: function (value)
    {
        if (this.backgroundColor === value) return;
        this.backgroundColor = value;
        this.backgroundBrush = new SolidBrush(this.backgroundColor);
    }
});

Object.defineProperty(InfoLineDataCacheTool.prototype, 'BackgroundBrush', {
    get: function () { return this.backgroundBrush; }
});

InfoLineDataCacheTool.prototype.MaxPointsCount = function () { return 2; };
InfoLineDataCacheTool.prototype.MinPointsCount = function () { return 2; };

InfoLineDataCacheTool.prototype.ThemeChanged = function (applyToTable)
{
    DataCacheTool.prototype.ThemeChanged.call(this, applyToTable);

    this.BackgroundColor = ThemeManager.CurrentTheme.Chart_InfoWindowBackColor;
    this.FontColor = ThemeManager.CurrentTheme.Chart_InfoWindowForeColor;
    this.Color = ThemeManager.CurrentTheme.Chart_InfoWindowForeColor;
    this.font = ThemeManager.Fonts.Font_8F_regular;
}

//#region ICaller

InfoLineDataCacheTool.prototype.Properties = function ()
{
    var oldProps = DataCacheTool.prototype.Properties.apply(this);
    var props = [];

    if (this.font)
        props.push(new DynProperty("Font", this.font.copy(), DynProperty.FONT, DynProperty.VISUAL_GROUP));

    var len = oldProps.length;
    for (var i = 0; i < len; i++)
    {
        var prop = oldProps[i];

        if (prop.group === DynProperty.NUMERICAL_PARAMETRS_GROUP || prop.group === DynProperty.HIDDEN_GROUP ||
            prop.name === "Stick to period" || prop.name === "Color")
            props.push(prop);
    }

    return props;
};

InfoLineDataCacheTool.prototype.callBack = function (properties)
{
    DataCacheTool.prototype.callBack.call(this, properties);

    var prop = DynProperty.getPropertyByName(properties, "Font");
    if (prop) this.font = prop.value;
};

//#endregion